module.exports = __webpack_public_path__ + "static/media/TextEnrichesGoodOptimized.bd7bb6a3.jp2";